/**
 * config/compliance.js
 * NIST CSF 2.0, ISO 27001, PCI-DSS, GDPR mappings
 */

// ── NIST CSF 2.0 Mapping ──────────────────────────────────────────────────────

export const NIST_MAP = {
  "Reconnaissance":     { function: "IDENTIFY",  category: "ID.RA", control: "Risk Assessment — Threat identification" },
  "Initial Access":     { function: "PROTECT",   category: "PR.AC", control: "Identity Management & Access Control" },
  "Credential Access":  { function: "PROTECT",   category: "PR.AC", control: "Authentication & Access Control" },
  "Command & Control":  { function: "DETECT",    category: "DE.CM", control: "Continuous Monitoring" },
  "Lateral Movement":   { function: "DETECT",    category: "DE.CM", control: "Network Monitoring" },
  "Exfiltration":       { function: "RESPOND",   category: "RS.MI", control: "Incident Mitigation" },
  "Impact":             { function: "RECOVER",   category: "RC.RP", control: "Recovery Planning" },
  "Defense Evasion":    { function: "DETECT",    category: "DE.AE", control: "Anomaly & Event Detection" },
  "Discovery":          { function: "IDENTIFY",  category: "ID.AM", control: "Asset Management" },
  "Persistence":        { function: "PROTECT",   category: "PR.IP", control: "Information Protection Processes" },
};
